import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { withNamespaces } from 'react-i18next';
import loader from '../../Comman/images/loader.gif'
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

var svValidator;
var engValidator;
var currentLang;

class AlarmStatusColorComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            RegionId:'',
            pendingAlarmStatus: '',
            pendingAlarmStatusColor: '',

            acceptAlarmStatus: '',
            acceptAlarmStatusColor: '',

            rejectAlarmStatus: '',
            rejectAlarmStatusColor: '',

            abortAlarmStatus: '',
            abortAlarmStatusColor: '',

            closeAlarmStatus: '',
            closeAlarmStatusColor: '',

            equipmentPickedAlarmStatus: '',
            equipmentPickedAlarmStatusColor: '',

            // acceptEquipmentAlarmStatus: '',
            // acceptEquipmentAlarmStatusColor: '',

            arrivedAlarmStatus: '',
            arrivedAlarmStatusColor: '',

            equipmentNotFoundAlarmStatus: '',
            equipmentNotFoundAlarmStatusColor: ''
        }
        this.handlePendingAlarmStatusColor = this.handlePendingAlarmStatusColor.bind(this);
        this.handleAcceptStatusColor = this.handleAcceptStatusColor.bind(this);
        this.handleRejectStatusColor = this.handleRejectStatusColor.bind(this);
        this.handleAbortStatusColor = this.handleAbortStatusColor.bind(this);
        this.handleCloseStatusColor = this.handleCloseStatusColor.bind(this);
        this.handleEquipmentPickedStatusColor = this.handleEquipmentPickedStatusColor.bind(this);
        // this.handleAcceptEquipmentStatusColor = this.handleAcceptEquipmentStatusColor.bind(this);
        this.handleArrivedStatusColor = this.handleArrivedStatusColor.bind(this);
        this.handleEquipmentNotFoundStatusColor = this.handleEquipmentNotFoundStatusColor.bind(this);


        if (sessionStorage.getItem('Language')) {
            currentLang = sessionStorage.getItem('Language');
        }
        else {
            currentLang = "en";
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.getAllAlarmStatusData.message != this.props.getAllAlarmStatusData.message) {
            if (nextProps.getAllAlarmStatusData.statusCode == 200) {
                swal(nextProps.getAllAlarmStatusData.message, {
                    icon: "success",
                });
                // this.props.getSMTPdata();
            }
        }
        this.translateLang();
    }
    translateLang() {
        var language;
        if (sessionStorage.getItem('Language')) {
            language = sessionStorage.getItem('Language');
        }
        else {
            language = "en";
        }
        if (language == "en") {
            this.validator = engValidator;
        }
        else {
            this.validator = svValidator;
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.getAllAlarmStatusData != this.props.getAllAlarmStatusData) {
            this.props.getAllAlarmStatusData.alarmStatusColorList.forEach(item => {
                if (item.AlarmStatus == "Pending") {
                    this.setState({
                        pendingAlarmStatus: item.AlarmStatus,
                        pendingAlarmStatusColor: item.AlarmStatusColor,
                    })
                }
                if (item.AlarmStatus == "Accept") {
                    this.setState({
                        acceptAlarmStatus: item.AlarmStatus,
                        acceptAlarmStatusColor: item.AlarmStatusColor,
                    })
                }
                if (item.AlarmStatus == "Reject") {
                    this.setState({
                        rejectAlarmStatus: item.AlarmStatus,
                        rejectAlarmStatusColor: item.AlarmStatusColor,
                    })
                }
                if (item.AlarmStatus == "Abort") {
                    this.setState({
                        abortAlarmStatus: item.AlarmStatus,
                        abortAlarmStatusColor: item.AlarmStatusColor,
                    })
                }
                if (item.AlarmStatus == "Close") {
                    this.setState({
                        closeAlarmStatus: item.AlarmStatus,
                        closeAlarmStatusColor: item.AlarmStatusColor,
                    })
                }
                if (item.AlarmStatus == "Equipment Picked") {
                    this.setState({
                        equipmentPickedAlarmStatus: item.AlarmStatus,
                        equipmentPickedAlarmStatusColor: item.AlarmStatusColor,
                    })
                }
                // if (item.AlarmStatus == "AcceptEquipment") {
                //     this.setState({
                //         acceptEquipmentAlarmStatus: item.AlarmStatus,
                //         acceptEquipmentAlarmStatusColor: item.AlarmStatusColor,
                //     })
                // }
                if (item.AlarmStatus == "Arrived") {
                    this.setState({
                        arrivedAlarmStatus: item.AlarmStatus,
                        arrivedAlarmStatusColor: item.AlarmStatusColor,
                    })
                }
                if (item.AlarmStatus == "EquipmentNotFound") {
                    this.setState({
                        equipmentNotFoundAlarmStatus: item.AlarmStatus,
                        equipmentNotFoundAlarmStatusColor: item.AlarmStatusColor,
                    })
                }
            })
        }
    }
    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required: 'The :attribute field is required.',
            min: 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required: 'Fältet :attribute krävs.',
            min: ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale: 'en'
            }
        );
        svValidator = new SimpleReactValidator(
            {
                locale: 'sv'
            }
        );
        this.validator = engValidator;
    }
    save() {
        let payload = [
            {
                "AlarmStatus": this.state.pendingAlarmStatus,
                "AlarmStatusColor": this.state.pendingAlarmStatusColor,
                   "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            },
            {
                "AlarmStatus": this.state.acceptAlarmStatus,
                "AlarmStatusColor": this.state.acceptAlarmStatusColor,
                 "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            },
            {
                "AlarmStatus": this.state.rejectAlarmStatus,
                "AlarmStatusColor": this.state.rejectAlarmStatusColor,
                "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            },
            {
                "AlarmStatus": this.state.abortAlarmStatus,
                "AlarmStatusColor": this.state.abortAlarmStatusColor,
                 "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            },
            {
                "AlarmStatus": this.state.closeAlarmStatus,
                "AlarmStatusColor": this.state.closeAlarmStatusColor,
                 "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            },
            {
                "AlarmStatus": this.state.equipmentPickedAlarmStatus,
                "AlarmStatusColor": this.state.equipmentPickedAlarmStatusColor,
                 "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            },
            // {
            //     "AlarmStatus": this.state.acceptEquipmentAlarmStatus,
            //     "AlarmStatusColor": this.state.acceptEquipmentAlarmStatusColor
            // },
            {
                "AlarmStatus": this.state.arrivedAlarmStatus,
                "AlarmStatusColor": this.state.arrivedAlarmStatusColor,
                "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            },
            {
                "AlarmStatus": this.state.equipmentNotFoundAlarmStatus,
                "AlarmStatusColor": this.state.equipmentNotFoundAlarmStatusColor,
                 "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            },
        ]
        this.props.updateStatusColor(payload);
    }
    handlePendingAlarmStatusColor(e) {
        console.log(e)
        this.setState({
            pendingAlarmStatusColor: e.target.value
        })
    }
    handleAcceptStatusColor(e) {
        this.setState({
            acceptAlarmStatusColor: e.target.value
        })
    }
    handleRejectStatusColor(e) {
        this.setState({
            rejectAlarmStatusColor: e.target.value
        })
    }
    handleAbortStatusColor(e) {
        this.setState({
            abortAlarmStatusColor: e.target.value
        })
    }
    handleCloseStatusColor(e) {
        this.setState({
            closeAlarmStatusColor: e.target.value
        })
    }
    handleEquipmentPickedStatusColor(e) {
        this.setState({
            equipmentPickedAlarmStatusColor: e.target.value
        })
    }
    // handleAcceptEquipmentStatusColor(e) {
    //     this.setState({
    //         acceptEquipmentAlarmStatusColor: e.target.value
    //     })
    // }
    handleArrivedStatusColor(e) {
        this.setState({
            arrivedAlarmStatusColor: e.target.value
        })
    }
    handleEquipmentNotFoundStatusColor(e) {
        this.setState({
            equipmentNotFoundAlarmStatusColor: e.target.value
        })
    }
    changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    render() {
        const { t } = this.props;
           let  regionListOption;
        let regionList=this.props.getAllAlarmStatusData.regionList;
      if(regionList){
          regionListOption = regionList.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Alarm Setting.Alarm Status Color Setting')}</h2>
                </div>
                 
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                     <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div><br></br>
                    <div className=" forms add-device setting-panel" style={{marginTop:'40px'}}>
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <form>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'>

                                            </div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="pending" className="form-label">{this.state.pendingAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.pendingAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="statuscolor"
                                                    value={this.state.pendingAlarmStatusColor}
                                                    onChange={this.handlePendingAlarmStatusColor} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'></div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="accept" className="form-label">{this.state.acceptAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.acceptAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="favcolor"
                                                    value={this.state.acceptAlarmStatusColor}
                                                    onChange={this.handleAcceptStatusColor} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'></div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="reject" className="form-label">{this.state.rejectAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.rejectAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="favcolor"
                                                    value={this.state.rejectAlarmStatusColor}
                                                    onChange={this.handleRejectStatusColor} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'></div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="abort" className="form-label">{this.state.abortAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.abortAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="favcolor"
                                                    value={this.state.abortAlarmStatusColor}
                                                    onChange={this.handleAbortStatusColor} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'></div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="close" className="form-label">{this.state.closeAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.closeAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="favcolor"
                                                    value={this.state.closeAlarmStatusColor}
                                                    onChange={this.handleCloseStatusColor} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'></div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="equipmentPicked" className="form-label">{this.state.equipmentPickedAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.equipmentPickedAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="favcolor"
                                                    value={this.state.equipmentPickedAlarmStatusColor}
                                                    onChange={this.handleEquipmentPickedStatusColor} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'></div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="acceptEquipment" className="form-label">{this.state.acceptEquipmentAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.acceptEquipmentAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="favcolor"
                                                    value={this.state.acceptEquipmentAlarmStatusColor}
                                                    onChange={this.handleAcceptEquipmentStatusColor} />
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'></div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="arrived" className="form-label">{this.state.arrivedAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.arrivedAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="favcolor"
                                                    value={this.state.arrivedAlarmStatusColor}
                                                    onChange={this.handleArrivedStatusColor} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className='col-md-4'></div>
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="EquipmentNotFound" className="form-label">{this.state.equipmentNotFoundAlarmStatus}</label>
                                            </div>
                                            <div className="col-md-6">
                                                <span className="box" id="fColor"
                                                    style={{ background: this.state.equipmentNotFoundAlarmStatusColor }}>
                                                </span>
                                                <input type="color" name="favcolor"
                                                    value={this.state.equipmentNotFoundAlarmStatusColor}
                                                    onChange={this.handleEquipmentNotFoundStatusColor} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* {
                                        (this.props.getAllAlarmStatusData && this.props.getAllAlarmStatusData.alarmStatusColorList.length) ?
                                            this.props.getAllAlarmStatusData.alarmStatusColorList.map((item, index) =>
                                                <div className="form-group">
                                                    <div className="row">
                                                        <div className="col-md-2 radio-label">
                                                            <label htmlFor="EmailId" className="form-label">{item.AlarmStatus}</label>
                                                        </div>
                                                        <div className="col-md-9">
                                                            <span className="box" id="fColor"
                                                                style={{ background: item.AlarmStatusColor }}>
                                                            </span>
                                                            <input type="color" id="favcolor" name="favcolor"
                                                                value={item.AlarmStatusColor}
                                                                onChange={this.handleInput} />
                                                            <div>
                                                                <button type="button" className="pickcolorbtn pickbtn "
                                                                    id="modalfcolor" onClick={this.handleColorBtnClick}>Pick Color</button>
                                                                {this.state.displayColorPicker ? <div style={popover}>
                                                                    <div style={cover} onClick={this.handleColorBtnClose} />
                                                                    <ChromePicker
                                                                        color={this.state.alarmStatusColor}
                                                                        onChangeComplete={this.handleColorChange}
                                                                    />
                                                                </div> : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                            : ''
                                    } */}

                                    <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p className='butn-center'>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary general-btn"
                                                    onClick={() => { this.save() }}
                                                    disabled={this.props.getAllAlarmStatusData.isLoading == true}
                                                >
                                                    {t('First_Responder.Save')}
                                                </button>
                                                {
                                                    this.props.getAllAlarmStatusData.isLoading ?
                                                        <img src={loader} width="30" alt="" /> : ''
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withNamespaces()(withRouter(AlarmStatusColorComponent));
